jQuery(document).ready(function($){
	$('.scfe-block-wrapper.google-drive-image-gallery .gallery-wrapper img').on('click', function(){
		var modalSrc = $(this).attr('modal_src');
		var parentDiv = $(this).closest('.scfe-block-wrapper.google-drive-image-gallery');

		parentDiv.find('.gallery-modal-img > img').attr('src', modalSrc);
		parentDiv.find('.gallery-modal-wrapper').addClass('showing');
		console.log(modalSrc);
	});

	$('.scfe-block-wrapper.google-drive-image-gallery .gallery-modal-wrapper .gallery-modal-bg').on('click', function(){
		var parentDiv = $(this).closest('.gallery-modal-wrapper');

		parentDiv.find('img').attr('src', '');
		parentDiv.removeClass('showing');
	});

	$('.scfe-block-wrapper.google-drive-image-gallery .gallery-modal-wrapper .gallery-modal-img').on('click', function(e){
		var parentDiv = $(this).closest('.gallery-modal-wrapper');

		parentDiv.find('img').attr('src', '');
		parentDiv.removeClass('showing');
	});

	$('.scfe-block-wrapper.google-drive-image-gallery .gallery-modal-wrapper .gallery-modal-img img').on('click', function(e){
		e.stopPropagation();
	});
});